<div class="row">
  <div class="col-sm-12 plan-container">
    @if (sub) {
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <fui-heading [text]="'fender_play.subscription_title' | translate" [level]="1" fontSize="f7"></fui-heading>
          <span class="pill m-l-10 gray" [class.green]="sub.status == 'active'">{{ statusMap[sub.status]?.title || "Unknown" }}</span>
        </div>
        <a class="btn btn-secondary" target="_blank" [href]="env.fenderPlayUrl" (click)="goToFenderPlay()">Go to Fender Play</a>
      </div>
      @if (!loading && !stripeSubscription) {
        <div class="fui-table m-t-20">
          <div class="fui-row">
            <div class="fui-label">{{ "sphere.account.status" | translate }}</div>
            <div class="fui-value">
              {{ sub.status == "pending" ? ("fender_play.status_pending_cancellation" | translate) : statusMap[sub.status]?.title || "Unknown" }}
              @if (sub.status == "pending") {
                <br />
                <span class="t-12">{{ "fender_play.subscription_active_through" | translate: { date: (sub.trialEndDate || sub.expirationDate | date: "MMM Do, YYYY") } }}</span>
              }
            </div>
          </div>
          <div class="fui-row">
            <div class="fui-label">{{ "general.created" | translate }}</div>
            <div class="fui-value">{{ sub.createdAt | date: "MMM Do, YYYY" }}</div>
          </div>
          <div class="fui-row">
            <div class="fui-label">{{ "sphere.subscription_details.exp" | translate }}</div>
            <div class="fui-value">{{ sub.expirationDate | date: "MMM Do, YYYY" }}</div>
          </div>
          @if (sub.termType || playSubscription?.termType) {
            <div class="fui-row">
              <div class="fui-label">{{ "fender_play.term" | translate }}</div>
              <div class="fui-value">{{ sub.termType || playSubscription?.termType }}</div>
            </div>
          }
        </div>
      }
      @if (!loading && stripeSubscription) {
        <div class="fui-table m-t-20">
          <div class="fui-row">
            <div class="fui-label">{{ "sphere.account.status" | translate }}</div>
            <div class="fui-value">
              {{ statusMap[stripeSubscription.status]?.title || stripeSubscription.status }}
              @if (stripeSubscription.cancel_at_period_end) {
                <br />
                <span class="t-12">{{ "fender_play.cancels_at_period_end" | translate }}</span>
              }
            </div>
          </div>
          @if (stripeSubscription.current_period_start) {
            <div class="fui-row">
              <div class="fui-label">{{ "general.created" | translate }}</div>
              <div class="fui-value">{{ stripeSubscription.current_period_start * 1000 | date: "MMM Do, YYYY" }}</div>
            </div>
          }
          @if (stripeSubscription.current_period_end) {
            <div class="fui-row">
              <div class="fui-label">{{ "sphere.subscription_details.exp" | translate }}</div>
              <div class="fui-value">{{ stripeSubscription.current_period_end * 1000 | date: "MMM Do, YYYY" }}</div>
            </div>
          }
          @if (stripeSubscription.items?.data?.length) {
            <div class="fui-row">
              <div class="fui-label">{{ "fender_play.term" | translate }}</div>
              <div class="fui-value">{{ stripeSubscription.items.data[0].price?.nickname || stripeSubscription.items.data[0].price?.id }}</div>
            </div>
            <div class="fui-row">
              <div class="fui-label">{{ "general.amount" | translate }}</div>
              <div class="fui-value">{{ stripeAmountDisplay }}</div>
            </div>
          }
        </div>
      }
      @if (!loading && !stripeSubscription && nextInvoice) {
        <div class="m-t-50">
          <fui-heading [text]="'account.your_next_invoice' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            <div class="col-4 col-lg-3">{{ "account.payment_date" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.periodStartDate | date: "MMM Do, YYYY" }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            <div class="col-4 col-lg-3">{{ "account.subtotal" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.amountDue + " " + nextInvoice.currency.toUpperCase() }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            <div class="col-4 col-lg-3">{{ "account.total" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.totalAmount + " " + nextInvoice.currency.toUpperCase() }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
        </div>
      }
      @if (!loading && !stripeSubscription && pastInvoices?.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.payment_history' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            @for (pay of pastInvoices; track pay) {
              <div class="col-4 col-lg-3">
                {{ pay.periodStartDate | date: "MMM Do, YYYY" }}
              </div>
              <div class="col-8 col-lg-9">
                <div class="d-flex justify-content-between">
                  <div>
                    <fa-icon icon="check-circle" class="c-green"></fa-icon>
                    <strong>
                      {{ pay.totalAmount + " " + pay.currency.toUpperCase() }}
                    </strong>
                  </div>
                  @if (pay.pdfUrl) {
                    <div>
                      <a class="small-btn text-nowrap" [href]="pay.pdfUrl" target="_blank">
                        <fa-icon icon="external-link"></fa-icon>
                        &nbsp; {{ "account.view_invoice" | translate }}
                      </a>
                    </div>
                  }
                </div>
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            }
          </div>
        </div>
      }
      @if (!loading && (sub.provider == "stripe" || sub.paymentSource == "stripe") && !loadingStripeDetails && stripeInvoices.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.payment_history' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            @for (inv of stripeInvoices; track inv.id) {
              <div class="col-4 col-lg-3">
                {{ inv.formattedDate }}
              </div>
              <div class="col-8 col-lg-9">
                <div class="d-flex justify-content-between">
                  <div>
                    @if (inv.status === "paid") {
                      <fa-icon icon="check-circle" class="c-green"></fa-icon>
                    } @else {
                      <fa-icon icon="exclamation-circle" class="c-orange"></fa-icon>
                    }
                    <strong>{{ inv.formattedAmount }} {{ inv.formattedCurrency }}</strong>
                    <span class="t-12 m-l-5">{{ inv.status }}</span>
                  </div>
                  @if (inv.hosted_invoice_url) {
                    <div>
                      <a class="small-btn text-nowrap" [href]="inv.hosted_invoice_url" target="_blank">
                        <fa-icon icon="external-link"></fa-icon>
                        &nbsp; {{ "account.view_invoice" | translate }}
                      </a>
                    </div>
                  }
                </div>
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            }
          </div>
        </div>
      }
      @if (!loading && (sub.provider == "stripe" || sub.paymentSource == "stripe")) {
        <div class="m-t-50">
          <fui-heading [text]="'account.payment_methods' | translate" [level]="3" fontSize="f5"></fui-heading>
          @if (loadingPlayPaymentMethods) {
            <div class="m-y-20">
              <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
            </div>
          }
          @if (!loadingPlayPaymentMethods && playPaymentMethods.length) {
            @for (method of playPaymentMethods; track method.id) {
              <myp-list-item
                [photo]="checkoutService.cardBrandIcons[method.card.brand] || checkoutService.cardBrandIcons.generic"
                [photoAlt]="method.card.brand + ' card'"
                [imageRound]="false"
                [imageBorder]="false"
                [includeChevron]="false"
                [hoverState]="false"
                [includeBottomBorder]="true"
                [title]="'Ending in ' + method.card.last4"
                [subData]="['Expires ' + method.card.exp_month + '/' + method.card.exp_year]"
              >
                <div class="button-content">
                  @if (playPaymentMethodLineItemLoaders[method.id]) {
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                  } @else {
                    @if (stripeDefaultPaymentMethodId === method.id) {
                      <span class="pill green m-r-10">Default</span>
                    } @else {
                      <button class="action m-r-5 no-border no-background" ngbTooltip="Make Default" (click)="setPlayCardAsDefault(method.id)">
                        <fa-icon icon="check"></fa-icon>
                        <span class="sr-only">Make Default</span>
                      </button>
                      @if (!blockPlayPaymentMethodDeletion) {
                        <button class="action m-r-5 no-border no-background" ngbTooltip="Delete Payment Method" (click)="deletePlayPaymentMethod(method.id)">
                          <fa-icon icon="times"></fa-icon>
                          <span class="sr-only">Delete Payment Method</span>
                        </button>
                      }
                    }
                  }
                </div>
              </myp-list-item>
            }
          }
          @if (!loadingPlayPaymentMethods && !playPaymentMethods.length) {
            <p>{{ "account.no_payment_methods" | translate }}</p>
          }

          <button class="brand-btn-reverse sm m-t-20" (click)="goToAddPlayPaymentMethod()">{{ "fender_play.change_payment_method" | translate }}</button>
        </div>
      }
      @if (!loading && sub.cardLast4 && sub.provider != "stripe" && sub.paymentSource != "stripe") {
        <div class="m-t-50">
          <fui-heading [text]="'account.payment_method' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            <div class="col-12">
              {{ sub.cardType + " **** **** **** " + sub.cardLast4 }}
              <hr class="m-y-10" />
            </div>
          </div>
        </div>
      }
      @if (sub.provider == "stripe" || sub.provider == "zuora" || sub.paymentSource == "stripe" || sub.paymentSource == "zuora") {
        <div class="m-t-50">
          @if (sub.provider != "zuora" && sub.paymentSource != "zuora") {
            <a class="brand-btn-reverse sm m-r-10 m-b-10" target="_blank" [href]="env.fenderPlayUrl + 'plans'">{{ "fender_play.change_subscription_plan" | translate }}</a>
          }
          @if (sub.provider == "zuora" || sub.paymentSource == "zuora") {
            <button class="brand-btn-reverse sm m-r-10 m-b-10" (click)="openZuoraPaypalModal()">{{ "fender_play.change_payment_method" | translate }}</button>
          }
          @if (sub.status != "active") {
            <a class="brand-btn-reverse sm m-r-10 m-b-10" target="_blank" [href]="env.fenderPlayUrl + 'redeem'">{{ "fender_play.redeem_code" | translate }}</a>
          }
          @if (userService.subDetails.play_subscription_normalized.status == "active") {
            <div class="m-t-20">
              <a class="small-btn" [href]="env.fenderConnectUrl + 'cancel'">{{ "fender_play.cancel_auto_renew" | translate }}</a>
            </div>
          }
        </div>
      }
      @if (sub.provider == "recharge" || sub.paymentSource == "recharge") {
        <div class="m-t-50">
          <a class="brand-btn-reverse sm m-r-10 m-b-10" href="javascript:void(0)" (click)="appService.goToFenderShop(env.shopifyAccountPageUrl)">
            {{ "fender_play.manage_subscription" | translate }}
            <fa-icon class="m-l-5" icon="external-link"></fa-icon>
          </a>
        </div>
      }
      @if (sub.provider == "apple" || sub.paymentSource == "apple") {
        <div class="m-t-50">
          {{ "fender_play.apple_subscription_message" | translate }}
          <br />
          <br />
          <a
            class="brand-btn-reverse sm m-r-10 m-b-10"
            target="_blank"
            href="https://play-support.fender.com/hc/en-us/articles/360004232531-If-I-subscribed-to-Fender-Play-from-an-iPhone-or-iPad-how-do-I-manage-my-subscription"
          >
            {{ "fender_play.learn_more" | translate }}
          </a>
        </div>
      }
      @if (sub.provider == "google" || sub.paymentSource == "google") {
        <div class="m-t-50">
          {{ "fender_play.google_subscription_message" | translate }}
          <br />
          <br />
          <a
            class="brand-btn-reverse sm m-r-10 m-b-10"
            target="_blank"
            href="https://play-support.fender.com/hc/en-us/articles/360004232571-If-I-subscribed-to-Fender-Play-from-an-Android-device-how-do-I-manage-my-subscription"
          >
            {{ "fender_play.learn_more" | translate }}
          </a>
        </div>
      }
      @if (!loading && transactions.length && (sub.provider == "zuora" || playSubscription?.paymentSource == "zuora")) {
        <div class="m-t-50">
          <fui-heading [text]="'fender_play.transactions' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div style="overflow-x: auto">
            <div class="fui-table" style="min-width: 700px">
              <div class="fui-row" style="font-weight: 600; font-size: 13px">
                <div style="flex: 2">{{ "general.date" | translate }}</div>
                <div style="flex: 1.5">{{ "general.payment_method" | translate }}</div>
                <div style="flex: 2.5">{{ "general.period" | translate }}</div>
                <div style="flex: 1; text-align: right">{{ "general.amount" | translate }}</div>
                <div style="flex: 1">{{ "general.status" | translate }}</div>
              </div>
              @for (t of paginatedTransactions; track t["invoice-id"]) {
                <div class="fui-row" style="font-size: 13px">
                  <div style="flex: 2">{{ t.formattedDate }}</div>
                  <div style="flex: 1.5">{{ t["payment-method"] || "—" }}</div>
                  <div style="flex: 2.5">{{ t.formattedStartDate }} – {{ t.formattedEndDate }}</div>
                  <div style="flex: 1; text-align: right">{{ t["currency-symbol"] }}{{ t.amount }}</div>
                  <div style="flex: 1">{{ t.status }}</div>
                </div>
              }
            </div>
          </div>
          @if (transactionsTotalPages > 1) {
            <div class="d-flex justify-content-between align-items-center m-t-10">
              <span class="t-14">{{ "general.page" | translate }} {{ transactionsPage }} {{ "general.of" | translate }} {{ transactionsTotalPages }}</span>
              <div>
                <button class="btn btn-sm btn-secondary m-r-5" [disabled]="transactionsPage === 1" (click)="transactionsPage = transactionsPage - 1">{{ "general.previous" | translate }}</button>
                <button class="btn btn-sm btn-secondary" [disabled]="transactionsPage === transactionsTotalPages" (click)="transactionsPage = transactionsPage + 1">
                  {{ "general.next" | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      }
      <div class="m-t-30">
        <a href="https://www.fender.com/pages/privacy-policy" target="_blank" class="tiny-link">
          {{ "account.privacy_policy_link" | translate }}
        </a>
        &nbsp;|&nbsp;
        <a href="https://www.fender.com/pages/eula" target="_blank" class="tiny-link">{{ "account.eula" | translate }}</a>
      </div>
    }
    @if (!sub && !loading) {
      <div>
        <div class="fui-header-hero lg">
          <div>
            <div class="d-flex justify-content-center m-b-20">
              <myp-svg id="fender-play-logo" class="svg-white" width="300" height="90"></myp-svg>
            </div>
            <span class="text-center fui-heading-font t-30">{{ "fender_play.hero_tagline" | translate }}</span>
            <div class="m-t-10">
              <a class="btn btn-secondary white m-t-40" target="_blank" [href]="env.fenderPlayUrl" (click)="learnMoreFenderPlay()">
                {{ "fender_play.learn_more" | translate }}
              </a>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <fui-heading [text]="'fender_play.subscription_title' | translate" [level]="2" fontSize="f9"></fui-heading>
        <fui-heading [text]="'fender_play.play_your_way' | translate" [level]="4" fontSize="f5"></fui-heading>
        <p>{{ "fender_play.description_1" | translate }}</p>
        <p>{{ "fender_play.description_2" | translate }}</p>
        <p>{{ "fender_play.description_3" | translate }}</p>
        <p>{{ "fender_play.description_4" | translate }}</p>
        <p>{{ "fender_play.description_5" | translate }}</p>
        <br />
        <a class="btn btn-secondary" target="_blank" [href]="env.fenderPlayUrl" (click)="learnMoreFenderPlay()">{{ "fender_play.learn_more" | translate }}</a>
      </div>
    }
  </div>
  <ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
</div>
